/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const CopyrightLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M16.29 9.43a5 5 0 1 0 0 5.14l-1.72-1.03a3 3 0 1 1 0-3.08zM22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0" />
  </Icon>
);
